<!--售后列表-->
<template>
  <div>
    <div class="service-apply-box app-border-top" v-for="(item, index) in list">
      <div class="remark-title flex-between">
        <span>{{ item.title }}</span>
        <!--            <div class='flex-end title-right status-'+item.admin_status>-->
        <div :class="'flex-end title-right status-' + item.admin_status">
          {{ item.status_name }}
        </div>
      </div>
      <div class="remark-user flex-between">
        <div class="remark-user-left flex-start">{{ item.user_name }}</div>
        <div class="remark-user-right specification gray">
          {{ item.create_time_str }}
        </div>
      </div>
      <div class="remark-span">{{ item.note }}</div>
      <div class="remark-pric remark-prics">
        <img
          class="remark-img"
          v-for="(pic, index) in item.pics"
          :src="pic.url"
        />
      </div>
      <div class="admin-note" v-if="item.admin_user_id">
        <div class="flex-between">
          <span class="flex-start gray">商家：{{ item.admin_user_name }}</span>
          <span class="time gray">{{ item.complete_time_string }}</span>
        </div>
        <div v-if="item.admin_note" class="note">{{ item.admin_note }}</div>
      </div>
      <div v-if="item.express_code" style="margin:2px 0"><span>回仓单号:{{item.express_code}}</span></div>
      <div style="width:100%;display: flex;justify-content: center;">
          <van-button
        style="background: #ee0a24; border-color: #ee0a24; padding: 0 0.8rem;"
        round
        type="info"
        @click="onServiceApplyCodeAdd(item)"
        >填写回仓单号</van-button
      >
      </div>
    </div>
    <!-- <div class="add-btn">
      <div class="add-b-b">
        
      </div>
    </div> -->
    <van-dialog v-model="show" title="售后寄回" show-cancel-button @confirm='onConfirm' @cancel="onCancel">
      <van-field v-model="value" label="单号:" placeholder="请输入寄回单号" />
    </van-dialog>
  </div>
</template>
<style scoped>
.add-btn {
  position: fixed;
  width: 100%;
  height: 1.3rem;
  bottom: 0.4rem;
}
.add-b-b {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.app-border-top {
  border-top: 5px solid #efefef;
}
.app-border-top:first-child {
  border-top: none;
}
.service-apply-box {
  padding: 0 15px;
}

.remark-title {
  padding: 15px 0;
  font-size: 13px;
}

.remark-prics {
  justify-content: space-around;
  display: flex;
}
.title-right {
  font-size: 12px;
}

.title-right span {
  color: #fd2840;
  margin-left: 5px;
}

.remark-user-img {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin-right: 5px;
}

.remark-span {
  font-size: 12px;
  padding: 7.5px 2.5px;
}

.remark-img {
  width: 30%;
  /*width: 70px;
        height: 70px;
        margin-right: 27.5px;*/
}

.remark-img:last-child {
  margin-right: 0;
}

.remark-img:last-child {
  margin-right: 0;
}

.specification {
  font-size: 12px;
  padding: 10px 0;
}

.admin-note {
  padding: 10px;
  background: #efefef;
  margin: 10px 0;
  border-radius: 10px;
  font-size: 12px;
}

.admin-note .note {
  padding: 8px 0 0 0;
  color: #1890ff;
}

.status-1 {
  color: #1890ff;
}

.status-2 {
  color: #fd2840;
}

.status-3 {
  color: #2aa198;
}
</style>

<script>
import { Button, Field, Popup, Picker, Dialog } from "vant";

export default {
  components: {
    Button,
    Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Dialog.Component.name]: Dialog.Component,
  },
  data: function () {
    return {
      show: false,
      value: "",
      orderId: 0,
      list: [],
      service_id:0
    };
  },
  filter: {},
  mounted() {
    document.title = "售后列表";
    this.getList();
  },
  destroyed() {},
  methods: {
    onServiceApplyCodeAdd(item) {
        this.show=true
        this.service_id=item.id
    },
    onConfirm(){
        let that=this
        this.$api.get(
        "/api/order/serviceApplyCodeAdd",
        { service_id: that.service_id,code:that.value },
        (res) => {
            that.$toast("添加成功");
            that.getList()
          console.log(res);
          
        }
      );
    },
    onCancel(){
        this.show=false
        this.value=''
        this.service_id=0

    },
    getList() {
      let that = this;
      that.orderId = that.$route.query.order_id;
      this.$api.get(
        "/api/order/serviceApplyList",
        { order_id: that.orderId },
        (res) => {
          console.log(res);
          that.list = res.data;
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// ServiceApplyList.vue?111c457e